import { render, staticRenderFns } from "./inspecttask.vue?vue&type=template&id=2b8f7d0c&"
import script from "./inspecttask.vue?vue&type=script&lang=js&"
export * from "./inspecttask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports